import TableRestaurantIcon from '@mui/icons-material/TableRestaurant'
import { Grid, Paper, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useThemeMode } from '../../../theme'
import { RegistrationCard } from './RegistrationCard'

export const RegistrationList = ({
  registrations,
  isAdmin,
  emptyMessage = 'snacks-no-registrations',
  ...cardCallbacks
}) => {
  const { t } = useTranslation()
  const { palette } = useThemeMode()
  const ownTableNumber = useSelector((state) => state.snacks.ownRegistration?.table_number)

  if (!Array.isArray(registrations) || registrations.length === 0) {
    return (
      <Paper elevation={2} sx={{ p: 4, textAlign: 'center', width: '100%' }}>
        <TableRestaurantIcon sx={{ fontSize: '3rem', color: palette.headerColor, opacity: 0.3, mb: 1 }} />
        <Typography variant="body2" color="text.secondary">
          {t(emptyMessage)}
        </Typography>
      </Paper>
    )
  }

  return (
    <Grid container className="companion-snacks-browser">
      {registrations.map((registration) => (
        <Grid item xs={12} key={registration.id}>
          <RegistrationCard
            registration={registration}
            isAdmin={isAdmin}
            linkTo={registration.table_number != null
              ? ownTableNumber === registration.table_number
                ? '/voting/snacks/my-table'
                : `/voting/snacks/${registration.table_number}`
              : undefined}
            {...cardCallbacks}
          />
        </Grid>
      ))}
    </Grid>
  )
}
